/* Bundle selector — paliers de quantité + variantes par article, prix dynamique,
   ajout multi-lignes au panier. Se simplifie si le produit n'a pas de variante. */
(function () {
  class BundleSelector extends HTMLElement {
    connectedCallback() {
      this.hasVariants = this.dataset.hasVariants === 'true';
      this.variants = this._json('[data-bundle-variants]') || [];
      this.tiers = Array.prototype.slice.call(this.querySelectorAll('.bundle-tier'));
      this.totalEl = this.querySelector('[data-total]');
      this.addBtn = this.querySelector('[data-add]');
      if (!this.tiers.length || !this.addBtn) return;
      this._bind();
      var start = this.querySelector('.bundle-tier.is-selected') || this.tiers[0];
      this._selectTier(start);
    }

    _json(sel) {
      var el = this.querySelector(sel);
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    _bind() {
      var self = this;
      this.tiers.forEach(function (t) {
        t.addEventListener('click', function (e) {
          if (e.target.closest('[data-seg]') || e.target.closest('select') ||
              e.target.closest('[data-guide-open]') || e.target.closest('[data-guide-close]')) return;
          self._selectTier(t);
        });
      });
      this.querySelectorAll('[data-seg]').forEach(function (seg) {
        seg.querySelectorAll('.bundle-seg__btn').forEach(function (b) {
          b.addEventListener('click', function (ev) {
            ev.preventDefault();
            seg.querySelectorAll('.bundle-seg__btn').forEach(function (x) { x.classList.remove('is-sel'); });
            b.classList.add('is-sel');
            self._recalc();
          });
        });
      });
      this.querySelectorAll('select[data-select]').forEach(function (s) {
        s.addEventListener('change', function () { self._recalc(); });
      });

      // Guide des tailles (dialog)
      var dlg = this.querySelector('[data-guide]');
      this.querySelectorAll('[data-guide-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); if (dlg && dlg.showModal) dlg.showModal(); });
      });
      this.querySelectorAll('[data-guide-close]').forEach(function (b) {
        b.addEventListener('click', function () { if (dlg && dlg.close) dlg.close(); });
      });
      if (dlg) dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

      this.addBtn.addEventListener('click', function () { self._add(); });
    }

    _selectTier(tier) {
      this.tiers.forEach(function (t) { t.classList.toggle('is-selected', t === tier); });
      this.current = tier;
      this._recalc();
    }

    // Retourne, pour un palier, la liste des articles { id, price }
    _itemsFor(tier) {
      var qty = parseInt(tier.dataset.qty, 10) || 1;
      if (!this.hasVariants) {
        var v0 = this.variants[0] || {};
        var arr = [];
        for (var i = 0; i < qty; i++) arr.push({ id: v0.id, price: v0.price || 0 });
        return arr;
      }
      var self = this;
      var cards = Array.prototype.slice.call(tier.querySelectorAll('.bundle-bracelet'));
      return cards.map(function (card) {
        var chosen = {};
        card.querySelectorAll('.bundle-opt').forEach(function (opt) {
          var idx = parseInt(opt.dataset.optIndex, 10);
          var seg = opt.querySelector('.bundle-seg__btn.is-sel');
          var sel = opt.querySelector('select');
          chosen[idx] = seg ? seg.dataset.value : (sel ? sel.value : null);
        });
        var v = self._match(chosen);
        return { id: v ? v.id : null, price: v ? v.price : 0 };
      });
    }

    _match(chosen) {
      return this.variants.find(function (v) {
        var opts = v.options || [];
        return Object.keys(chosen).every(function (i) {
          return opts[i] === chosen[i];
        });
      });
    }

    _recalc() {
      var self = this;
      var unitText = this.dataset.unitText || 'soit {prix} le bracelet';
      // Prix affiché sur chaque palier (+ sous-texte « soit X le bracelet » pour les packs)
      this.tiers.forEach(function (t) {
        var items = self._itemsFor(t);
        var tot = items.reduce(function (s, it) { return s + (it.price || 0); }, 0);
        var pe = t.querySelector('[data-tier-price]');
        if (pe) pe.textContent = self._money(tot);
        var qty = parseInt(t.dataset.qty, 10) || 1;
        var sub = t.querySelector('[data-tier-subtext]');
        if (sub && qty > 1 && items.length) {
          sub.textContent = unitText.replace('{prix}', self._money(tot / qty));
        }
      });
      // Total + état bouton pour le palier courant
      if (!this.current) return;
      var cur = this._itemsFor(this.current);
      var total = cur.reduce(function (s, it) { return s + (it.price || 0); }, 0);
      if (this.totalEl) this.totalEl.textContent = this._money(total);
      var ok = cur.every(function (it) { return it.id; });
      this.addBtn.disabled = !ok;
    }

    _money(cents) {
      var n = (cents / 100);
      return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    _add() {
      var self = this;
      var raw = this._itemsFor(this.current).filter(function (it) { return it.id; });
      if (!raw.length) return;
      // Fusionne les variantes identiques en quantité
      var merged = {};
      raw.forEach(function (it) { merged[it.id] = (merged[it.id] || 0) + 1; });
      var items = Object.keys(merged).map(function (id) { return { id: Number(id), quantity: merged[id] }; });

      // Demande aussi le re-rendu de la section panier (tiroir) dans la réponse
      var payload = { items: items };
      var comp = document.querySelector('cart-items-component');
      if (comp && comp.dataset && comp.dataset.sectionId) {
        payload.sections = comp.dataset.sectionId;
        payload.sections_url = window.location.pathname;
      }

      this.addBtn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          self.addBtn.classList.remove('is-loading');
          self._openCart();
        })
        .catch(function () {
          self.addBtn.classList.remove('is-loading');
          window.location = '/cart';
        });
    }

    // Met à jour le tiroir IMMÉDIATEMENT (bon nom d'événement) puis l'ouvre.
    _openCart() {
      var self = this;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return null; })
        .then(function (cart) {
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
          // Événement écouté par le tiroir du thème ET par lp-cart (réconciliation cadeaux)
          var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
          ev.action = 'update';
          ev.promise = Promise.resolve({ detail: { itemCount: count } });
          document.dispatchEvent(ev);
          self._openDrawer();
        });
    }

    _openDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
      var toggle = document.querySelector('[data-cart-drawer-open], [aria-controls*="cart-drawer" i], a[href$="/cart"], a[href*="/cart"]');
      if (toggle) { toggle.click(); }
    }
  }

  if (!customElements.get('bundle-selector')) {
    customElements.define('bundle-selector', BundleSelector);
  }
})();
